module.exports = __webpack_public_path__ + "img/weichatpay_img.afd0dc7d.png";